import * as ExcelJS from "exceljs";
import {removeHtmlTags} from "@/utils/index";
import store from '@/store'


export async function surveyToExcel(surveyData, mandantName, surveySheetName, coverSheetFunc = coverSheet => {}, surveyResult = {}) {
  const workbook = new ExcelJS.Workbook();
  // cover sheet
  // Add a new sheet before the first sheet
  const coverSheet = workbook.addWorksheet('Start');

  await coverSheetFunc(coverSheet, mandantName)

  const worksheet = workbook.addWorksheet(surveySheetName);
  if (['AV-Prüfung', 'TOM'].includes(surveySheetName)) {
    await makeSurveySheet(worksheet, surveyData, surveySheetName, surveyResult);
  } else {
    await makeSurveySheetWithLanguage(worksheet, surveyData, store.getters.language, surveyResult)
  }

  // Export to Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${surveySheetName}-${mandantName.replace(/\s+/g, '')}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function makeTOMCoverSheet(coverSheet, mandantName) {

  // Add text to A3 and B3 with light blue background
  coverSheet.getCell('A3').value = 'Beschreibung: ';
  coverSheet.getCell('B3').value = 'Dieses Excel-Dokument dient der schnellen Überprüfung von TOM (Technische und organisatorische Maßnahmen) gemäß Art. 32 DSGVO. Es handelt sich um eine reine Standaufnahme. Je nach System und verarbeiteten Daten können unterschiedliche Maßnahmen sinnvoll sein. Es ist daher nicht notwendig, dass alle Maßnahmen oder abgefragten Umsetzungen implementiert sind. Allerdings müssen Sie mittels Risikoanalyse klären, ob bestimmte Maßnahmen für Ihr Unternehmen relevant sind.\n';
  coverSheet.getCell('A4').value = 'Anwendung: ';
  coverSheet.getCell('B4').value = 'Im Tabellenblatt "TOM" finden Sie in den Spalten A bis C die relevanten Punkte, die als technische Maßnahmen zur Sicherheit personenbezogener Daten enthalten sein können, sowie deren spezifische Ausgestaltung. Die Spalten A bis C sind fixiert und können nicht verändert werden. \n' +
    '\n' +
    'Bitte gehen Sie die einzelnen Prüfpunkte in Spalte B durch und geben Sie in Spalte C und F die jeweilige Antwort dazu an.';
  coverSheet.getCell('A5').value = 'Vorgehen, Schritt für Schritt: ';
  coverSheet.getCell('B5').value = {
    richText: [
      { text: '1. Vorbereitung: ', font: { bold: true } },
      { text: 'Füllen Sie die Rahmenbedingungen (grau) im Excel-Sheet (Tabellenblatt) "START" aus.\n', font: { bold: false } },
      { text: '2. Prüfung starten: ', font: { bold: true } },
      { text: 'Beginnen Sie die Prüfung im Tabellenblatt "TOM" und prüfen Sie systematisch alle Prüfpunkte (Spalte B) gegen die umgesetzten Maßnahmen.\n', font: { bold: false } },
      { text: '3. Antworten auswählen: ', font: { bold: true } },
      { text: 'Wählen Sie die passende Antwort in Spalte F aus und geben Sie weitere relevante Informationen in Spalte C an.\n', font: { bold: false } },
      { text: '4. Erläuterung bei "Bemerkungen": ', font: { bold: true } },
      { text: 'Tragen Sie ergänzende Hinweise ein (z. B. Verweis auf Dokumente, konkrete Umsetzungsdetails oder Begründungen für „TEILWEISE“/„NEIN“).\n', font: { bold: false } },
      { text: '5. Lücken dokumentieren: ', font: { bold: true } },
      { text: 'Halten Sie nicht erfüllte Anforderungen („NEIN“/„TEILWEISE“) in einer separaten Liste (z. B. „TOM-Mängelübersicht“) fest. Nutzen Sie die Bemerkung aus Spalte G, um die Gründe für Nicht-Erfüllung nachvollziehbar zu machen.\n', font: { bold: false } },
      { text: '6. Verbesserungspotenzial ableiten: ', font: { bold: true } },
      { text: 'Identifizieren Sie langfristige Optimierungsmaßnahmen (z. B. Aktualisierung von Prozessen, Schulungen, technische Nachbesserungen).\n', font: { bold: false } },
      { text: '7. Rücksendung an die Kanzlei: ', font: { bold: true } },
      { text: 'Die Kanzlei erstellt auf Basis Ihrer Angaben eine formale TOM-Beschreibung (Dokumentation der umgesetzten Maßnahmen).\n', font: { bold: false } },
    ]
  };

  ['A3', 'B3', 'A4', 'B4', 'A5', 'B5'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFE6F2FF'} // Light blue
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
    cell.border = {
      top: {style:'thin', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'FF000000'}},
      right: {style:'thin', color: {argb:'FF000000'}}
    };
  });

  coverSheet.getCell('A8').value = 'Mandant: ';
  coverSheet.getCell('B8').value = mandantName;
  coverSheet.getCell('A9').value = 'Adresse: ';
  coverSheet.getCell('A10').value = 'Land: ';
  coverSheet.getCell('A12').value = 'Datum der Prüfung: ';
  coverSheet.getCell('A13').value = 'Prüfung durchgeführt von: ';
  coverSheet.getCell('A14').value = 'identifizierte Risiken: ';
  coverSheet.getCell('A15').value = 'Maßnahmen: ';

  ['A8', 'B8', 'A9', 'B9', 'A10', 'B10', 'A12', 'B12', 'A13', 'B13', 'A14', 'B14', 'A15', 'B15'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFF2F2F2'} // Light Gray
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
    cell.border = {
      top: {style:'thin', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'FF000000'}},
      right: {style:'thin', color: {argb:'FF000000'}}
    };
  });

  ['A25', 'B25', 'A26', 'B26'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFFCD5B4'} // Light Gray
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
    cell.border = {
      top: {style:'thin', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'FF000000'}},
      right: {style:'thin', color: {argb:'FF000000'}}
    };
  });

  ['A3', 'B3', 'A4', 'B4', 'A5', 'B5', 'A8', 'A9', 'A10', 'A11', 'A14', 'A15', 'A16', 'A17', 'A20', 'A21', 'A22', 'A25', 'A26'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.protection = { locked: true };
  });

  ['B8', 'B9', 'B10', 'B11', 'B14', 'B15', 'B16', 'B17', 'B20', 'B21', 'B22', 'B25', 'B26'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.protection = { locked: false };
  });

  // Protect the worksheet
  await coverSheet.protect('Max und Mietz', {
    selectLockedCells: true,
    selectUnlockedCells: true,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    insertRows: false,
    insertHyperlinks: false,
    deleteColumns: false,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false
  });

  // Merge A7 and B7, add text with light gray background
  coverSheet.mergeCells('A7:B7');
  const mergedCell = coverSheet.getCell('A7');
  mergedCell.value = 'RAHMENINFORMATIONEN';
  mergedCell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'FFBFBFBF'} // Light gray
  };

  // Set column widths
  coverSheet.columns = [
    { width: 36 }, // Page title column width
    { width: 155 },
  ];
}


export async function makeAVCoverSheet(coverSheet, mandantName='') {

  // Add text to A3 and B3 with light blue background
  coverSheet.getCell('A3').value = 'Beschreibung: ';
  coverSheet.getCell('B3').value = 'Dieses Excel-Dokument ist für eine schnelle Überprüfung von Auftragsverarbeitungsvertragen auf die Einhaltung der in der Datenschutzgrundverordnung (EU-DSGVO) geforderten Regelungen zur Sicherheit von personenbezogenen Daten gedacht. Es soll, angewandt als Checkliste, eine Übersicht über mögliche Risiken, sowie Handlungsbedarf in Auftragsverarbeitungsverträgen aufzeigen. Es ersetzt jedoch nicht eine detaillierte Überprüfung durch einen Anwalt, Datenschutzbeauftragte/n oder sonstige fachkunde Person. \n';
  coverSheet.getCell('A4').value = 'Anwendung: ';
  coverSheet.getCell('B4').value = ' Im "AV-Prüfung" finden Sie in den Spalten A-E die relevanten Punkte, die für die Regelung der Sicherheit von personenbezogenen Daten im Auftragsverarbeitungsvertrag enthalten sein müssen, sowie deren Ausgestaltung. Die Spalten A bis E sind fixiert und können nicht geändert werden. \n' +
    '\n' +
    'Bitte gehen Sie die einzelnen Prüfpunkte in Spalte B durch und wählen Sie bei Fragen des Typs "Einzelauswahl" die passende Antwort aus. Bei Fragen des Typs "Mehrfachauswahl" kopieren Sie die jeweils passende Antwort aus Spalte E in Spalte F.';
  coverSheet.getCell('A5').value = 'Vorgehen, Schritt für Schritt: ';
  coverSheet.getCell('B5').value = {
    richText: [
      { text: '1. Vorbereitung: ', font: { bold: true } },
      { text: 'Füllen Sie die Rahmenbedingungen (grau) im Excel-Sheet (Tabellenblatt) "START" aus.\n', font: { bold: false } },
      { text: '2. Prüfung starten: ', font: { bold: true } },
      { text: 'Beginnen Sie die Prüfung im Tabellenblatt "AV-Prüfung", indem Sie den Vertrag auf die Prüfpunkte (Spalte B) prüfen.\n', font: { bold: false } },
      { text: '3. Antworten auswählen: ', font: { bold: true } },
      { text: 'Wählen Sie bei Fragen des Typs "Einzelauswahl" die passende Antwort aus. Bei Fragen des Typs ', font: { bold: false } },
      { text: '"Mehrfachauswahl" ', font: { bold: true } },
      { text: 'kopieren Sie ', font: { bold: false } },
      { text: 'alle zutreffenden Antworten ', font: { bold: true } },
      { text: 'aus Spalte E in Spalte F.\n', font: { bold: false } },
      { text: '4. Erläuterung bei "Sonstiges": ', font: { bold: true } },
      { text: 'Wenn Sie die Antwortmöglichkeit "Sonstiges" wählen, sollten Sie eine Erklärung in Spalte G einfügen.\n', font: { bold: false } },
      { text: '5. Überprüfung der Antworten: ', font: { bold: true } },
      { text: 'Sobald Sie alle Prüfpunkte durchgeprüft haben, kontrollieren Sie die Antwortspalte F darauf, ob "NEIN" oder "Sonstiges" in den Antworten enthalten ist.\n', font: { bold: false } },
      { text: '6. Handlungsbedarf: ', font: { bold: true } },
      { text: 'Wenn die Umsetzung der Anforderungen (Prüfpunkte) mit "NEIN" oder ggf. über "Sonstiges" nicht vollständig erfüllt sind, besteht Handlungsbedarf. Die Beschreibung in Spalte C hilft dabei zu verstehen, aus welchen Gründen dies nicht ausreichend ist.\n', font: { bold: false } },
      { text: '7. Risiken identifizieren: ', font: { bold: true } },
      { text: 'Übernehmen Sie die nicht erfüllten Prüfpunkte in die identifizierten Risiken.\n', font: { bold: false } },
      { text: '8. Maßnahmen ergreifen: ', font: { bold: true } },
      { text: 'Erstellen Sie zu den Risiken Maßnahmen, beispielsweise Änderungen im Vertrag.\n', font: { bold: false } },
      { text: '9. Kommunikation mit dem Vertragspartner: ', font: { bold: true } },
      { text: 'Sprechen Sie mit dem Vertragspartner bzw. Vertrags-owner über identifizierte Risiken.', font: { bold: false } }
    ]
  };

  ['A3', 'B3', 'A4', 'B4', 'A5', 'B5'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFE6F2FF'} // Light blue
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
    cell.border = {
      top: {style:'thin', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'FF000000'}},
      right: {style:'thin', color: {argb:'FF000000'}}
    };
  });

  coverSheet.getCell('A8').value = 'Auftragsverarbeiter: ';
  coverSheet.getCell('A9').value = 'Name: ';
  coverSheet.getCell('A10').value = 'Adresse: ';
  coverSheet.getCell('A11').value = 'Land: ';
  coverSheet.getCell('A14').value = 'Auftraggeber: ';
  coverSheet.getCell('A15').value = 'Name: ';
  coverSheet.getCell('A16').value = 'Adresse: ';
  coverSheet.getCell('A17').value = 'Land: ';
  coverSheet.getCell('A20').value = 'Name Vertrag: ';
  coverSheet.getCell('A21').value = 'Datum der Prüfung: ';
  coverSheet.getCell('A22').value = 'Prüfung durchgeführt von: ';
  coverSheet.getCell('A25').value = 'identifizierte Risiken: ';
  coverSheet.getCell('A26').value = 'Maßnahmen: ';

  ['A8', 'B8', 'A9', 'B9', 'A10', 'B10', 'A11', 'B11', 'A14', 'B14', 'A15', 'B15', 'A16', 'B16', 'A17', 'B17', 'A20', 'B20', 'A21', 'B21', 'A22', 'B22'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFF2F2F2'} // Light Gray
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
    cell.border = {
      top: {style:'thin', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'FF000000'}},
      right: {style:'thin', color: {argb:'FF000000'}}
    };
  });

  ['A25', 'B25', 'A26', 'B26'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'FFFCD5B4'} // Light Gray
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
    cell.border = {
      top: {style:'thin', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'FF000000'}},
      right: {style:'thin', color: {argb:'FF000000'}}
    };
  });

  ['A3', 'B3', 'A4', 'B4', 'A5', 'B5', 'A8', 'A9', 'A10', 'A11', 'A14', 'A15', 'A16', 'A17', 'A20', 'A21', 'A22', 'A25', 'A26'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.protection = { locked: true };
  });

  ['B8', 'B9', 'B10', 'B11', 'B14', 'B15', 'B16', 'B17', 'B20', 'B21', 'B22', 'B25', 'B26'].forEach(cellAddress => {
    const cell = coverSheet.getCell(cellAddress);
    cell.protection = { locked: false };
  });

  // Protect the worksheet
  await coverSheet.protect('Max und Mietz', {
    selectLockedCells: true,
    selectUnlockedCells: true,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    insertRows: false,
    insertHyperlinks: false,
    deleteColumns: false,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false
  });

  // Merge A7 and B7, add text with light gray background
  coverSheet.mergeCells('A7:B7');
  const mergedCell = coverSheet.getCell('A7');
  mergedCell.value = 'RAHMENINFORMATIONEN';
  mergedCell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'FFBFBFBF'} // Light gray
  };

  // Set column widths
  coverSheet.columns = [
    { width: 36 }, // Page title column width
    { width: 155 },
  ];
}

export async function makeSurveySheet(worksheet, surveyData, surveyType = '', surveyResult = {}) {
  const headerStyle = {
    font: { bold: true, size: 13 },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA8A8A8' } },
    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }
  };

  const headerYellowStyle = {
    font: { bold: true, size: 13 },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } },
    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }
  };

  const subHeaderStyle = {
    font: { bold: true },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } },
    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true }
  };

  const cellStyle = {
    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true }
  };

  const editCellStyle = {
    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true }
  };

  // Add header row
  const headerRow = worksheet.addRow(['Bereich', 'Prüfpunkte','Beschreibung', 'Fragetyp', 'Auswahl', 'Antwort', 'Bemerkungen']);
  headerRow.eachCell((cell) => {
    if (cell.value === 'Prüfpunkte') cell.style = headerYellowStyle;
    else cell.style = headerStyle;
  });

  let rowIndex = 2; // Start from the second row (after header)
  const hiddenColumnIndex = 14; // Start from column N (14th column)
  let endHiddenColumnIndex = 14;
  let headerRows = [1];

  // Helper to format the answer so it matches the Excel dropdown validation text perfectly
  function getFormattedAnswer(element, rawAnswer) {
    if (rawAnswer === undefined || rawAnswer === null || rawAnswer === '') return '';

    if (element.type === 'radiogroup' || element.type === 'checkbox' || element.type === 'dropdown') {
      const isArray = Array.isArray(rawAnswer);
      const answers = isArray ? rawAnswer : [rawAnswer];

      const formattedAnswers = answers.map(ans => {
        if (element.choices) {
          // Find the matching choice by its value
          const choiceIndex = element.choices.findIndex(c => {
            const val = (typeof c === 'object' && c !== null && c.value !== undefined) ? c.value : c;
            return val === ans;
          });

          // Format it to match the "1. Text" format defined in your choice mapping
          if (choiceIndex !== -1) {
            const choice = element.choices[choiceIndex];
            const textStr = (typeof choice === 'object' && choice !== null && choice.text !== undefined) ? choice.text : choice;
            return `${choiceIndex + 1}. ${textStr}`;
          }
        }
        return typeof ans === 'object' ? JSON.stringify(ans) : String(ans);
      });

      return formattedAnswers.join('\n');
    }

    // For plain text, booleans, or other input types
    return typeof rawAnswer === 'object' ? JSON.stringify(rawAnswer) : String(rawAnswer);
  }

  surveyData.pages.forEach((page) => {
    // Check if title exists to avoid runtime errors before splitting
    const pageTitle = page.title ? page.title.split('.')[0] : '';

    page.elements.forEach((element) => {
      if (element.type === 'html') {
        // Add HTML content as header
        const htmlRow = worksheet.addRow([pageTitle, stripHtml(element.html)]);
        worksheet.mergeCells(`B${rowIndex}:G${rowIndex}`);
        htmlRow.eachCell((cell) => {
          cell.style = subHeaderStyle;
        });
        headerRows.push(rowIndex);
      } else {
        // --- NEW LOGIC: Map answers and comments ---
        const elName = element.name; // SurveyJS maps answers using the element's name
        let answerText = '';
        let commentText = '';

        if (elName && surveyResult) {
          answerText = getFormattedAnswer(element, surveyResult[elName]);
          // Standard SurveyJS convention: comments are saved with "-Comment" suffix
          commentText = surveyResult[`${elName}-Comment`] || '';
        }

        const row = worksheet.addRow([
          pageTitle,
          element.title,
          element.description ? stripHtml(element.description) : '',
          getQuestionType(element.type),
          element.type === 'radiogroup' || element.type === 'checkbox'
            ? element.choices.map((choice, index) => {
              const textStr = typeof choice === 'object' && choice.text !== undefined ? choice.text : choice;
              return `${index + 1}. ${textStr}`;
            }).join('\n')
            : '',
          answerText,  // Fills Column F (Antwort)
          commentText  // Fills Column G (Bemerkungen)
        ]);

        row.eachCell((cell) => {
          cell.style = cellStyle;
        });

        // Add data validation for dropdowns in the answer column
        if (element.type === 'radiogroup') {
          // Copy choices to hidden columns
          element.choices.forEach((choice, index) => {
            const textStr = typeof choice === 'object' && choice.text !== undefined ? choice.text : choice;
            const cellAddress = `${getExcelColumnLetter(hiddenColumnIndex + index)}${rowIndex}`;
            worksheet.getCell(cellAddress).value = `${index + 1}. ${textStr}`;
          });

          // Create data validation formula
          const startColumn = getExcelColumnLetter(hiddenColumnIndex);
          const endColumnIndex = hiddenColumnIndex + element.choices.length - 1;
          const endColumn = getExcelColumnLetter(endColumnIndex);
          if (endColumnIndex > endHiddenColumnIndex) endHiddenColumnIndex = endColumnIndex;
          const formula = `$${startColumn}$${rowIndex}:$${endColumn}$${rowIndex}`;

          worksheet.getCell(`F${rowIndex}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [formula]
          };
        }

        worksheet.getCell(`F${rowIndex}`).style = editCellStyle;
        worksheet.getCell(`G${rowIndex}`).style = editCellStyle;
      }
      rowIndex++;
    });
  });

  // Set column widths
  worksheet.columns = [
    { width: 30 }, // Page title column width
    { width: 60 },
    { width: 80 },
    { width: 20 },
    { width: 85 },
    { width: 20 },
    { width: 30 }
  ];

  for (let i = hiddenColumnIndex; i <= endHiddenColumnIndex+1; i++) {
    worksheet.getColumn(i).hidden = true;
  }

  worksheet.columns.forEach((column, index) => {
    // Unlock columns 5 (Antwort) and 6 (Bemerkungen)
    if (index === 5 || index === 6) {
      column.eachCell((cell) => {
        if (!headerRows.includes(cell._row._number)) {
          cell.protection = { locked: false };
        }
      });
    }
  });

  // Protect the worksheet
  await worksheet.protect('Max und Mietz', {
    selectLockedCells: true,
    selectUnlockedCells: true,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    insertRows: false,
    insertHyperlinks: false,
    deleteColumns: false,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false
  });

  // hide two columns in case of TOM
  if (surveyType === 'TOM') {
    worksheet.getColumn(3).hidden = true; // Hides "Beschreibung"
    worksheet.getColumn(4).hidden = true;
    worksheet.getColumn(5).hidden = true;
  }
}

export async function makeSurveySheetWithLanguage(worksheet, surveyData, lang = 'de', surveyResult = {}) {
  const headerStyle = {
    font: { bold: true, size: 13 },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA8A8A8' } },
    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }
  };

  const headerYellowStyle = {
    font: { bold: true, size: 13 },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } },
    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }
  };

  const subHeaderStyle = {
    font: { bold: true },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } },
    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true }
  };

  const cellStyle = {
    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true }
  };

  const editCellStyle = {
    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true }
  };

  // Add header row
  const headerRow = worksheet.addRow(['Bereich', 'Prüfpunkte','Beschreibung', 'Fragetyp', 'Auswahl', 'Antwort', 'Bemerkungen']);
  headerRow.eachCell((cell) => {
    if (cell.value === 'Prüfpunkte') cell.style = headerYellowStyle;
    else cell.style = headerStyle;
  });

  let rowIndex = 2; // Start from the second row (after header)
  const hiddenColumnIndex = 14; // Start from column N (14th column)
  let endHiddenColumnIndex = 14;
  let headerRows = [1];

  function getAttributeWithFallback(obj, attributeName) {
    if (!obj) return '';
    // Safety check in case the object is a simple string instead of a localized object
    if (typeof obj === 'string') return typeof removeHtmlTags === 'function' ? removeHtmlTags(obj) : obj;

    if (obj.hasOwnProperty(attributeName)) {
      return typeof removeHtmlTags === 'function' ? removeHtmlTags(obj[attributeName]) : obj[attributeName];
    } else if (obj['de']) {
      // Fallback to 'de' if the attribute does not exist
      return typeof removeHtmlTags === 'function' ? removeHtmlTags(obj['de']) : obj['de'];
    }
    return '';
  }

  // Helper to format the answer so it matches the Excel dropdown validation text perfectly
  function getFormattedAnswer(element, rawAnswer) {
    if (rawAnswer === undefined || rawAnswer === null || rawAnswer === '') return '';

    if (element.type === 'radiogroup' || element.type === 'checkbox' || element.type === 'dropdown') {
      const isArray = Array.isArray(rawAnswer);
      const answers = isArray ? rawAnswer : [rawAnswer];

      const formattedAnswers = answers.map(ans => {
        if (element.choices) {
          // Find the matching choice by its actual underlying value
          const choiceIndex = element.choices.findIndex(c => {
            const val = (typeof c === 'object' && c !== null && c.value !== undefined) ? c.value : c;
            return val === ans;
          });

          // Format it to match the "1. Text" format defined in your choice map
          if (choiceIndex !== -1) {
            const choice = element.choices[choiceIndex];
            const textObj = (typeof choice === 'object' && choice !== null && choice.text !== undefined) ? choice.text : choice;
            return `${choiceIndex + 1}. ${getAttributeWithFallback(textObj, lang)}`;
          }
        }
        return typeof ans === 'object' ? JSON.stringify(ans) : String(ans);
      });

      return formattedAnswers.join('\n');
    }

    // For plain text, booleans, or other input types
    return typeof rawAnswer === 'object' ? JSON.stringify(rawAnswer) : String(rawAnswer);
  }

  surveyData.pages.forEach((page) => {
    const pageTitle = getAttributeWithFallback(page.title, lang);

    page.elements.forEach((element) => {
      if (element.type === 'html') {
        const htmlRow = worksheet.addRow([pageTitle, stripHtml(element.html)]);
        worksheet.mergeCells(`B${rowIndex}:G${rowIndex}`);
        htmlRow.eachCell((cell) => {
          cell.style = subHeaderStyle;
        });
        headerRows.push(rowIndex);
      } else {
        // --- NEW LOGIC: Map answers and comments ---
        const elName = element.name; // SurveyJS maps answers using the element's name
        let answerText = '';
        let commentText = '';

        if (elName && surveyResult) {
          answerText = getFormattedAnswer(element, surveyResult[elName]);
          // Standard SurveyJS convention: comments are saved with "-Comment" suffix
          commentText = surveyResult[`${elName}-Comment`] || '';
        }

        const row = worksheet.addRow([
          pageTitle,
          getAttributeWithFallback(element.title, lang),
          getAttributeWithFallback(element.description, lang) ? stripHtml(getAttributeWithFallback(element.description, lang)) : '',
          getQuestionType(element.type),
          element.type === 'radiogroup' || element.type === 'checkbox'
            ? element.choices.map((choice, index) => {
              const textObj = (typeof choice === 'object' && choice.text !== undefined) ? choice.text : choice;
              return `${index + 1}. ${getAttributeWithFallback(textObj, lang)}`;
            }).join('\n')
            : '',
          answerText,  // Fills Column F (Antwort)
          commentText  // Fills Column G (Bemerkungen)
        ]);

        row.eachCell((cell) => {
          cell.style = cellStyle;
        });

        if (element.type === 'radiogroup') {
          element.choices.forEach((choice, index) => {
            const textObj = (typeof choice === 'object' && choice.text !== undefined) ? choice.text : choice;
            const cellAddress = `${getExcelColumnLetter(hiddenColumnIndex + index)}${rowIndex}`;
            worksheet.getCell(cellAddress).value = `${index + 1}. ${getAttributeWithFallback(textObj, lang)}`;
          });

          const startColumn = getExcelColumnLetter(hiddenColumnIndex);
          const endColumnIndex = hiddenColumnIndex + element.choices.length - 1;
          const endColumn = getExcelColumnLetter(endColumnIndex);
          if (endColumnIndex > endHiddenColumnIndex) endHiddenColumnIndex = endColumnIndex;
          const formula = `$${startColumn}$${rowIndex}:$${endColumn}$${rowIndex}`;

          worksheet.getCell(`F${rowIndex}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [formula]
          };
        }

        worksheet.getCell(`F${rowIndex}`).style = editCellStyle;
        worksheet.getCell(`G${rowIndex}`).style = editCellStyle;
      }
      rowIndex++;
    });
  });

  // Set column widths
  worksheet.columns = [
    { width: 30 },
    { width: 60 },
    { width: 80 },
    { width: 20 },
    { width: 85 },
    { width: 20 }, // Answer
    { width: 30 }  // Comment
  ];

  for (let i = hiddenColumnIndex; i <= endHiddenColumnIndex + 1; i++) {
    worksheet.getColumn(i).hidden = true;
  }

  worksheet.columns.forEach((column, index) => {
    // index 5 is F (Antwort), index 6 is G (Bemerkungen)
    if (index === 5 || index === 6) {
      column.eachCell((cell) => {
        if (!headerRows.includes(cell._row._number)) {
          cell.protection = { locked: false };
        }
      });
    }
  });
}

function getExcelColumnLetter(colIndex) {
  let letter = '';
  while (colIndex >= 0) {
    letter = String.fromCharCode((colIndex % 26) + 65) + letter;
    colIndex = Math.floor(colIndex / 26) - 1;
  }
  return letter;
}

function stripHtml(html) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

function getQuestionType(type) {
  switch (type) {
    case 'radiogroup':
      return 'Einzelauswahl';
    case 'checkbox':
      return 'Mehrfachauswahl';
    default:
      return 'Text';
  }
}

function removeNBSP(str) {
  return str// Remove UTF-8 encoded NBSP (C2 A0)
    .replace(/\xC2\xA0/g, ' ')
    // Remove Unicode NBSP
    .replace(/\u00A0/g, ' ')
    // Remove HTML entity NBSP
    .replace(/&nbsp;/g, ' ').trim();
}

